import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { GeneralIconTag } from '~/common/define/icon'
import { SpaceColor } from '~/common/define/color'
import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import SupportButton from '~/components/atoms/button/SupportButton'
import { ButtonSize } from '~/components/atoms/button/ButtonBase'
import { ClickProps } from '~/common/define/props'
import IconText from '~/components/atoms/icon/IconText'

interface Props extends ClickProps {
  text: string
  color: SpaceColor
}

const NavigationMenuNew = ({onClick, text, color}: Props) => {
  return (
    <div className={styles.menu__new}>
      <SupportButton onClick={onClick} size={ButtonSize.SMALL}>
        <IconText tag={GeneralIconTag.ADD_CROSS}
                  textSize={IconSize.X_SMALL} size={IconSize.XXX_SMALL}
                  fillColor={IconColor.WHITE}
                  frame={IconFrame.CIRCLE} bgColor={color}>
          {text}
        </IconText>
      </SupportButton>
    </div>
  )
}

export default NavigationMenuNew